import { type JSX, type ComponentType } from "react"
import { Navigate } from "react-router"

import { usePlatform } from "~/contexts/PlatformContext"
import { useUser } from "~/contexts/UserContext"
import { hasAccessToViewCommunity } from "~/utilities/community"
import routes from "~/utilities/routes"

export default function withCommunityAuthCheck<T extends JSX.IntrinsicAttributes>(
	Component: ComponentType<T>,
): ComponentType<T> {
	return (props: T) => {
		const user = useUser().user!
		const platform = usePlatform().platform

		if (platform.community === null || !hasAccessToViewCommunity(user, platform.community)) {
			return <Navigate to={routes.dashboard.index()} />
		}

		return <Component {...props} />
	}
}
